import { render, staticRenderFns } from "./PtIgaFormNode.vue?vue&type=template&id=b0dc690e&scoped=true&"
import script from "./PtIgaFormNode.vue?vue&type=script&lang=js&"
export * from "./PtIgaFormNode.vue?vue&type=script&lang=js&"
import style0 from "./PtIgaFormNode.vue?vue&type=style&index=0&id=b0dc690e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dc690e",
  null
  
)

export default component.exports